﻿import Webcam from './lib/webcam-capture';

const jQuery = window.jQuery;

export default class Verification {
    constructor() {
        this.checkout = jQuery('#checkout');
        if (localStorage.getItem('checkout_store')) {
            this.store = JSON.parse(localStorage.getItem('checkout_store'));
        }
        if (!this.store) {
            this.store = {
                verification_step: {
                    documents: {
                        id: null,
                        id_key: false,
                    },
                    current: false,
                },
            };
        }
        // user_id is a session-lifetime cookie (no expiry set elsewhere) used only as
        // an immediate cross-callback flag within a single webcam capture attempt —
        // clear it here so a stale true from an earlier attempt can't make a fresh
        // capture look complete.
        utilities.setCookie('user_id', '', -1);
        Webcam.set({
            image_format: 'jpeg',
            jpeg_quality: 90,
            force_flash: false,
            width: 600,
            height: 440,
        });
    }

    // The chooser modal (#changeDocumentModal) replaced its hidden #nationality/#document-type
    // inputs with a nationality tab switch (lib/content-tabs.js) and a
    // verify_document_type radio group (lib/document-type-toggle.js) as part of the Verification
    // tab redesign — these two helpers read the equivalent values from that markup.
    getDocumentType() {
        return jQuery('#changeDocumentModal input[name="verify_document_type"]:checked').val();
    }

    getNationality() {
        return jQuery('#changeDocumentModal .content-tabs__panel:not([hidden])').data('nationality');
    }

    initVerificationStep() {
        var self = this;
        const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        var verificationStepDiv = jQuery('#changeDocumentModal');
        if (verificationStepDiv.length) {
            jQuery('#site-footer').addClass('d-none');

            var takeAPhotoDocumentModal = jQuery('#takeAPhotoDocument');
            takeAPhotoDocumentModal.on('dialog:open', function () {
                var userIdPhotoBtn = jQuery('#user-id-photo');
                var userIdPhotoBtnWrapper = userIdPhotoBtn.parent();
                var takeSnapshotBtn = jQuery('#take_snapshot');
                var takeSnapshotMsg = takeSnapshotBtn.text();

                userIdPhotoBtn.off().on('click', function (e) {
                    e.preventDefault();
                    Webcam.reset();
                    takeSnapshotBtn.removeAttr('disabled');
                    userIdPhotoBtnWrapper.css('max-width', '100%');
                    userIdPhotoBtnWrapper.css('flex', '0 0 100%');
                    setTimeout(function () {
                        userIdPhotoBtn.css('padding', '10px 10px');
                        userIdPhotoBtn.html('<div id="camera" style="margin: auto;"></div>');
                        Webcam.attach('#camera');
                    }, 1000);
                    takeSnapshotBtn.text(takeSnapshotBtn.data('take-a-photo-msg'));
                    takeSnapshotBtn.off('click').click(function (e) {
                        e.preventDefault();
                        Webcam.snap(function (data_uri) {
                            userIdPhotoBtnWrapper.css('max-width', '');
                            userIdPhotoBtnWrapper.css('flex', '');
                            userIdPhotoBtnWrapper.find('#camera').remove();
                            userIdPhotoBtn.css('padding', 'unset');
                            userIdPhotoBtn.html('<img src="' + data_uri + '" style="margin: auto;">');
                            takeSnapshotBtn.text(takeSnapshotMsg);
                            utilities.setCookie('user_id', true);
                            let document_type = self.getDocumentType();
                            self.upoadUserFile(data_uri, false, document_type + ' - origin', 'webcam');
                            Webcam.reset();
                            if (utilities.getCookie('user_id')) {
                                takeSnapshotBtn.off('click').click(function (e) {
                                    e.preventDefault();
                                    self.verifyDocuments(
                                        takeSnapshotBtn,
                                        userIdPhotoBtnWrapper,
                                        takeAPhotoDocumentModal
                                    );
                                });
                            }
                        });
                    });
                });
            });

            var uploadAPhotoDocumentModal = jQuery('#uploadAPhotoDocument');
            uploadAPhotoDocumentModal.on('dialog:open', function () {
                var uploadFileMaxSize = 3000;
                var uploadBtn = jQuery('#upload_photo');
                var userIdInput = jQuery('#user_id');

                userIdInput.off('change').on('change', function () {
                    var errorMessage = jQuery(this).parent().find('.invalid-feedback');
                    var file = this.files[0];
                    var fileSize = Math.round(file.size / 1024);

                    if (jQuery.inArray(file.type, validImageTypes) < 0) {
                        errorMessage.text('Invalid file type');
                        errorMessage.css('display', 'block');
                        errorMessage.css('font-size', '100%');
                    } else if (fileSize > uploadFileMaxSize) {
                        errorMessage.text('The size of the uploaded file exceeds 5mb');
                        errorMessage.css('display', 'block');
                        errorMessage.css('font-size', '100%');
                    } else {
                        errorMessage.css('display', 'none');
                        let document_type = self.getDocumentType();
                        self.upoadUserFile(file, userIdInput, document_type + ' - origin', undefined, function () {
                            self.updateUploadButtonState(uploadBtn);
                        });
                    }
                });

                uploadBtn.off('click').on('click', function (e) {
                    e.preventDefault();
                    self.verifyDocuments(uploadBtn, userIdInput.parent(), uploadAPhotoDocumentModal);
                });
            });

            var manuallyModal = jQuery('#manuallyDocument');
            manuallyModal.on('dialog:open', function () {
                var verifyBtn = jQuery('#manuallySubmit');
                var contentContainer = jQuery('#manuallyDocument .message');
                verifyBtn.off('click').on('click', function (e) {
                    e.preventDefault();
                    let form = jQuery('#manuallySubmitForm');
                    let form_is_valid = true;
                    form.find('input[required]').each(function () {
                        let field = jQuery(this).closest('.form-field');
                        let isValid =
                            !!jQuery(this).val() &&
                            jQuery(this).val().length >= parseInt(jQuery(this).attr('data-min-length'));
                        field.toggleClass('form-field--error', !isValid);
                        field.find('.form-field__error').text(isValid ? '' : jQuery(this).attr('data-error-required'));
                        if (!isValid) {
                            form_is_valid = false;
                        }
                    });
                    if (!form_is_valid) {
                        return false;
                    }
                    verifyBtn.prev('.invalid-feedback').text('').removeClass('custom');
                    jQuery.ajax('/wp/wp-admin/admin-ajax.php', {
                        method: 'POST',
                        dataType: 'json',
                        data: {
                            action: 'amenities_verify_documents',
                            security: twf.account_nonce,
                            type: self.getDocumentType(),
                            nationality: self.getNationality(),
                            date_of_birth: jQuery('#modal_date_of_birth').val(),
                            expiration_date: jQuery('#modal_expiration_date').val(),
                            document_id: jQuery('#modal_document_id').val(),
                        },
                        success: function (response) {
                            if (response.status === 'success') {
                                // manuallyModal.find('form').children().remove();

                                var form = verifyBtn.parents('form');
                                form.children().remove();

                                manuallyModal.find('form').addClass('text-center');
                                manuallyModal
                                    .find('form')
                                    .append(
                                        '<div class="col-12">' +
                                            '<img src="' +
                                            twf.theme_path +
                                            '/static/img/icons/check-purple.svg" alt="" style="width: 5em; height: 5em; margin-bottom: 50px;">' +
                                            '<h5>' +
                                            contentContainer.data('success-title') +
                                            '</h5>' +
                                            '<p>' +
                                            contentContainer.data('success-message') +
                                            '</p>' +
                                            '<a href="/account" class="btn-gradient"><span>' +
                                            'My account</span></a>' +
                                            '</div>'
                                    );

                                verifyBtn.off('click').click(function (e) {
                                    e.preventDefault();
                                    manuallyModal.find('[data-dialog-dismiss]').first().click();
                                });
                            } else {
                                // Inline failure message instead of the previous window.location.replace("/")
                                // (silently bounced the user to the homepage) — the fields stay filled in
                                // and the existing click handler above already supports retrying.
                                var errorMessage = verifyBtn.prev('.invalid-feedback');
                                errorMessage
                                    .addClass('custom')
                                    .html(
                                        '<strong>' +
                                            contentContainer.data('fail-title') +
                                            '</strong><br>' +
                                            contentContainer.data('fail-message')
                                    );
                            }
                        },
                    });
                });
            });
        } else {
            alert('Something went wrong');
        }
    }

    verifyDocuments(verifyBtn, userIdWrapper, modal) {
        var self = this;
        if (!self.store.verification_step.documents.id) {
            verifyBtn
                .parent('div')
                .find('.invalid-feedback')
                .text('You should upload a photo of your ID document.')
                .addClass('custom');
            return false;
        } else {
            verifyBtn.parent('div').find('.invalid-feedback').text('').removeClass('custom');
        }
        var contentContainer = userIdWrapper.parent();
        verifyBtn.html('<i class="fas fa-spinner fa-spin"></i>');
        jQuery.ajax({
            url: twf.ajax_url,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'amenities_verify_documents',
                security: twf.account_nonce,
                type: self.getDocumentType(),
                nationality: self.getNationality(),
                document_origin: self.store.verification_step.documents.id,
                document_origin_key: self.store.verification_step.documents.id_key,
            },
            success: function (response) {
                if (response.status === 'success') {
                    var dialogHeader = modal.find('.dialog__header');
                    dialogHeader
                        .find('.dialog__icon')
                        .html('<img src="' + twf.theme_path + '/static/img/icons/check-purple.svg" alt="">');
                    dialogHeader.find('.dialog__title').text(contentContainer.data('success-title'));
                    dialogHeader.find('.dialog__description').text(contentContainer.data('success-message'));

                    contentContainer.remove();
                    verifyBtn.text(verifyBtn.data('continue-msg'));

                    verifyBtn.off('click').click(function (e) {
                        e.preventDefault();
                        modal.find('[data-dialog-dismiss]').first().click();
                        window.location.reload();
                    });
                } else {
                    userIdWrapper.hide();
                    contentContainer.prev().hide();
                    contentContainer.addClass('text-center');
                    contentContainer.append(
                        '<div class="col-12" id="fail-verification-msg">' +
                            '<i class="fas fa-times-circle" style="color: red; font-size: 5em; margin-bottom: 50px;"></i>' +
                            '<h5>' +
                            contentContainer.data('fail-title') +
                            '</h5>' +
                            '<p>' +
                            contentContainer.data('fail-message') +
                            '</p>' +
                            '</div>'
                    );
                    verifyBtn.text(verifyBtn.data('try-again-msg'));

                    verifyBtn.off('click').click(function (e) {
                        e.preventDefault();
                        verifyBtn.text(verifyBtn.data('verify-msg'));
                        verifyBtn.off('click').click(function (e) {
                            e.preventDefault();
                            self.verifyDocuments(verifyBtn, userIdWrapper, modal);
                        });
                        userIdWrapper.show();
                        contentContainer.prev().show();
                        jQuery('#fail-verification-msg').remove();
                    });
                }
            },
        });
    }

    updateUploadButtonState(uploadBtn) {
        if (this.store.verification_step.documents.id) {
            uploadBtn.removeAttr('disabled');
        }
    }

    upoadUserFile(file, file_input, document_type, image_type, onSuccess) {
        if (document_type === undefined) {
            document_type = 'swiss_id - origin';
        }
        if (image_type === undefined) {
            image_type = 'input';
        }
        const self = this;
        let reader = new FormData();
        reader.append('file_data', file);
        reader.append('action', 'upload_file_date');
        reader.append('security', twf.account_nonce);
        reader.append('user_id', twf.current_user_id);
        reader.append('document_type', document_type);
        reader.append('image_type', image_type);
        jQuery.ajax({
            url: twf.ajax_url,
            type: 'POST',
            data: reader,
            cache: false,
            dataType: 'json',
            processData: false,
            contentType: false,
            beforeSend: function () {
                window.jQuery.LoadingOverlay('show');
            },
            complete: function () {
                window.jQuery.LoadingOverlay('hide');
            },
            success: function (data, textStatus, jqXHR) {
                if (data.success) {
                    if (document_type.indexOf('origin') !== -1) {
                        self.store.verification_step.documents.id = data.data.file_url;
                        self.store.verification_step.documents.id_key = data.data.file_key;
                    } else {
                        self.store.verification_step.documents.selfie = data.data.file_url;
                        self.store.verification_step.documents.selfie_key = data.data.file_key;
                    }
                    if (file_input) {
                        file_input
                            .prev()
                            .html(
                                '<div class="upload_img_wrp" data-filekey="' +
                                    data.data.file_key +
                                    '"><img class="upload_img_cont" src="' +
                                    data.data.file_url +
                                    '" style="width: ' +
                                    file_input.parent().innerWidth() +
                                    '; height: ' +
                                    file_input.parent().innerHeight() +
                                    ';"></div>'
                            );
                    }
                    if (typeof onSuccess === 'function') {
                        onSuccess();
                    }
                } else {
                    alert('Problem with file uploading.');
                    console.log(data.data);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                let errorMessage = 'File upload error: ' + errorThrown + ' URL: ' + window.location.href;
                alert(errorMessage);
            },
        });
    }

    initRemoveFile(img_wrp, user_id, document_type) {
        const file_key = img_wrp.attr('data-filekey');
        if (!file_key || file_key.length < 10) {
            return;
        }
        const btn = img_wrp.find('.upload_img_remove');
        btn.on('click', function () {
            jQuery.ajax({
                url: twf.ajax_url,
                type: 'POST',
                data: {
                    action: 'remove_file_date',
                    user_id: user_id,
                    document_type: document_type,
                    file_key: file_key,
                },
                dataType: 'json',
                beforeSend: function () {
                    window.jQuery.LoadingOverlay('show');
                },
                complete: function () {
                    window.jQuery.LoadingOverlay('hide');
                },
                success: function (data, textStatus, jqXHR) {
                    if (data.success) {
                        img_wrp.fadeOut(500, function () {
                            img_wrp.remove();
                        });
                    } else {
                        alert('Problem with file uploading.');
                        console.log(data.data);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    let errorMessage = 'File upload error: ' + errorThrown + ' URL: ' + window.location.href;
                    alert(errorMessage);
                },
            });
        });
    }

    init() {
        this.initVerificationStep();
    }
}
